import { Column } from 'react-table'
import { columnGenerators } from '../../../../../../_metronic/helpers'

const header = [
  {
    label: 'S.N',
    value: 'id',
  },
  {
    label: 'Name',
    value: 'name',
  },
  {
    label: 'Type',
    value: 'processType',
  },
  {
    label: 'Output',
    value: 'inMaterials',
  },
  {
    label: 'Ep',
    value: 'EpV',
  },
  {
    label: 'GHg info',
    value: 'GHg',
  },
  // {
  //   label: 'Cost',
  //   value: 'processCost',
  // },
  {
    label: 'My trips',
    action: ['edit', 'toggle'],
  },
]

const roleColumns: ReadonlyArray<Column<any>> = columnGenerators(header)

export { roleColumns }